<template>
<div class="JobIntension">
    <div class="input_box">
        <van-cell-group>
            <van-field v-model="objectiveFromData.wishindustry" label="期望行业" placeholder="最多10个字" maxlength="10" />
            <van-field v-model="objectiveFromData.wishjobname" label="期望职位" placeholder="最多10个字" maxlength="10" />
            <van-cell clickable :title="`期望地点`" @click="togglePlace()">
                <div class="wishplace_div">
                    <p v-if="objectiveFromData.wishplace === ''" style="color: #999;">请选择</p>
                    <p v-else style="color: #333;">{{objectiveFromData.wishplace}}</p>
                    <img :src="require('@/common/images/mtalentimgs/icon_right.png')" alt="">
                </div>
            </van-cell>
            <van-field v-model="objectiveFromData.wishsalary" label="期望最少年薪" type="digit" placeholder="请填写"><template #button><span>万/年</span></template></van-field>
            <van-field v-model="objectiveFromData.wishsalarymax" label="期望最多年薪" type="digit" placeholder="请填写"><template #button><span>万/年</span></template></van-field>
        </van-cell-group>
    </div>
    <div class="select_pop_box">
        <van-action-sheet v-model="selectCityPop" close-on-click-action>
            <div class="content">
                <van-picker title="期望地点" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
            </div>
        </van-action-sheet>
    </div>
    <div class="bottom_btn_box">
        <div @click="cancelBtn" class="cancel_btn">取消</div>
        <div @click="saveBtn" class="save_btn">保存</div>
    </div>
</div>
</template>

<script>
import {getResumBasicInfo, updatePurposeInfo} from 'api/talentApi'
import {mapGetters, mapActions} from 'vuex'
import {Toast} from 'vant'
export default {
    name: 'JobIntension',
    data() {
        return {
            selectCityPop: false,
            columns: ['北京', '上海', '广州', '深圳', '成都', '杭州', '苏州', '东莞', '佛山', '武汉', '长沙', '重庆'],
            objectiveFromData: {
                innerid: '',
                wishindustry: '',
                wishjobname: '',
                wishplace: '',
                wishsalary: '',
                wishsalarymax: ''
            },
        }
    },
    mounted() {
        if (this.$route.query.innerid) {
            this.findResumBasicInfo()
        }
    },
    methods: {
        findResumBasicInfo() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.innerid
            }
            getResumBasicInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.objectiveFromData.innerid = data.data.innerid
                    this.objectiveFromData.wishindustry = data.data.wishindustry
                    this.objectiveFromData.wishjobname = data.data.wishjobname
                    this.objectiveFromData.wishplace = data.data.wishplace
                    this.objectiveFromData.wishsalary = data.data.wishsalary
                    this.objectiveFromData.wishsalarymax = data.data.wishsalarymax
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        togglePlace() {
            this.selectCityPop = true
        },
        onConfirm(value, index) {
            console.log(value)
            console.log(index)
            this.selectCityPop = false
            this.objectiveFromData.wishplace = value
        },
        onCancel() {
            this.selectCityPop = false
        },
        cancelBtn() {
            this.$router.back()
        },
        saveBtn() {
            if (this.objectiveFromData.wishindustry === '') {
                Toast('请填写期望行业')
                return
            }
            if (this.objectiveFromData.wishjobname === '') {
                Toast('请填写期望职位')
                return
            }
            if (this.objectiveFromData.wishplace === '') {
                Toast('请选择期望地点')
                return
            }
            if (this.objectiveFromData.wishsalary === '') {
                Toast('请填写期望最少年薪')
                return
            }
            if (this.objectiveFromData.wishsalary < 0) {
                Toast('期望最少年薪不能为负')
                return
            }
            var regPos = /^\d+(\.\d+)?$/
            var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
            if(!(regPos.test(this.objectiveFromData.wishsalary) || regNeg.test(this.objectiveFromData.wishsalary))){
                Toast('期望最少年薪请输入数字')
                return
            }
            var integer = /^[1-9]*[1-9][0-9]*$/
            if (!(parseInt(this.objectiveFromData.wishsalary) === 0)) {
                if (!integer.test(this.objectiveFromData.wishsalary)) {
                    Toast('期望最少年薪请输入正整数')
                    return
                }
            }
            if (this.objectiveFromData.wishsalarymax === '') {
                Toast('请填写期望最多年薪')
                return
            }
            if (this.objectiveFromData.wishsalarymax < 0) {
                Toast('期望最多年薪不能为负')
                return
            }
            if(!(regPos.test(this.objectiveFromData.wishsalarymax) || regNeg.test(this.objectiveFromData.wishsalarymax))){
                Toast('期望最多年薪请输入数字')
                return
            }
            if (!(parseInt(this.objectiveFromData.wishsalarymax) === 0)) {
                if (!integer.test(this.objectiveFromData.wishsalarymax)) {
                    Toast('期望最多年薪请输入正整数')
                    return
                }
            }
            if (parseInt(this.objectiveFromData.wishsalary) > parseInt(this.objectiveFromData.wishsalarymax)) {
                Toast('期望最少年薪不能大于期望最多年薪')
                return
            }
            this.setLoading(true)
            var params = this.objectiveFromData
            updatePurposeInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.JobIntension {
    font-family:PingFangSC-Regular,PingFang SC;
    min-height: 100vh;
    padding-bottom: 2.02rem;
    box-sizing: border-box;
    background-color: #fff;
    .input_box {
        .van-cell__title {
            display: flex;
            align-items: center;
            margin-bottom: 0.2rem;
        }
        .van-cell {
            display: flex;
            flex-direction: column;
            padding: 0.26rem 0.32rem;
            .van-cell__title {
                color: #666;
            }
        }
        .wishplace_div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &>img {
                width: 0.15rem;
                height: 0.25rem;
            }
        }
    }
    .select_pop_box {
        .van-popup--bottom.van-popup--round {
            border-radius: 0;
        }
    }
    .bottom_btn_box {
        background-color: #fff;
        position: fixed;
        bottom: 0;
        width: 100vw;
        display: flex;
        justify-content: space-between;
        padding: 0 0.32rem;
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
        box-sizing: border-box;
        .cancel_btn {
            background-color: #F8F8F8;
            color: #666;
            width: 2.2rem;
            height: 0.82rem;
            line-height: 0.82rem;
            text-align: center;
            font-size: 0.32rem;
        }
        .save_btn {
            background-color: #409EFF;
            color: #FFF;
            width: 4.36rem;
            height: 0.82rem;
            line-height: 0.82rem;
            text-align: center;
            font-size: 0.32rem;
        }
    }
}
</style>